import screenConfiguration from "../screen-configuration/reducer";

const rootReducer = {
  screenConfiguration
};

export default rootReducer;
